export default __webpack_public_path__ + "alberta-annotation.64ca6f0409acb8fb7f22.svg";